import { render } from "./FaultContentPhotos.vue?vue&type=template&id=6c51b33a&scoped=true"
import script from "./FaultContentPhotos.vue?vue&type=script&lang=js"
export * from "./FaultContentPhotos.vue?vue&type=script&lang=js"

import "./FaultContentPhotos.vue?vue&type=style&index=0&id=6c51b33a&lang=scss&scoped=true"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c51b33a"]])

export default __exports__